<template>
  <div class="flex justify-center">
    <div class="max-w-[1366px] h-screen flex items-center w-full">
      <section class="self-start max:mr-10 min-w-[400px] relative flex-1 h-screen grid grid-rows-[140px_1fr_auto]">
        <!-- Logo 區域 -->
        <div class="relative">
          <img
            src="@/assets/images/logo-splash.svg"
            alt="gsn-logo"
            class="absolute top-[70px] left-[60px]"
          />
        </div>
        
        <!-- 內容區域 -->
        <div class="mid:overflow-y-auto hide-scrollbar flex justify-center">
          <div class="w-[400px] py-8 my-auto">
            <slot />
          </div>
        </div>
        
        <!-- Partner Network 區域 -->
        <div class="mid:hidden flex flex-col items-center mb-10">
          <p>Partner Network</p>
          <img src="@/assets/images/signup/partner_network.png" alt="" />
        </div >
      </section>
      
      <section class="max-w-[50%] flex-1 max-mid:hidden overflow-x-hidden">
        <img
          src="@/assets/images/signup/login_image.png"
          alt=""
          class="max-max:translate-x-[10px] max-max:w-[85%] max:translate-x-[0px] max:max-w-[761px] max-max:max-w-none max:w-full"
        />
      </section>
    </div>
  </div>
</template>

<style scoped>
.hide-scrollbar {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.hide-scrollbar::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}
</style>